<div class="tile">
  <div class="row">
    <div class="col-12 d-flex justify-content-between align-items-center">
      <h5>{{ 'statistics.my-stats.headline' | transloco }}</h5>
      @if (!loading) {
        <span data-zid="info-icon" (click)="modal.open(modalContent, { size: 'lg' })">
          <svg class="icon icon-18 cursor-pointer">
            <use xlink:href="/assets/img/svgs/svgset.svg#info" />
          </svg>
        </span>
      }
    </div>
  </div>
  <div class="row">
    @if (!loading) {
      @if (stats) {
        <div class="col-12 mt-4 opacity-container" [class.active]="stats">
          <table class="table" aria-describedby="my-stats">
            <tr>
              <th>{{ 'statistics.my-stats.labels.accountTotal' | transloco }}</th>
              <td data-zid="my-stats-account-total">
                {{ accountTotal | currency }}
              </td>
            </tr>
            <tr>
              <th>{{ 'statistics.my-stats.labels.cashTotal' | transloco }}</th>
              <td data-zid="my-stats-cash-total">
                {{ stats.cashTotal | currency }}
              </td>
            </tr>
            <tr>
              <th>{{ 'statistics.my-stats.labels.total' | transloco }}</th>
              <td data-zid="my-stats-total">
                {{ stats.cashTotal + accountTotal | currency }}
              </td>
            </tr>
            <tr>
              <th>{{ 'statistics.my-stats.labels.cashIn' | transloco }}</th>
              <td data-zid="my-stats-cash-in-total">
                {{ stats.cashPayInTotal | currency }}
              </td>
            </tr>
            <tr>
              <th>{{ 'statistics.my-stats.labels.cashOut' | transloco }}</th>
              <td data-zid="my-stats-cash-out-total">
                {{ stats.cashPayOutTotal | currency }}
              </td>
            </tr>
            <tr>
              <th>{{ 'statistics.my-stats.labels.sumInAndOut' | transloco }}</th>
              <td data-zid="my-stats-portfolio-in-out-total">
                {{ stats.portfolioTransferTotal | currency }}
              </td>
            </tr>
            @if (stats.portfolioTransferTotal === 0) {
              <tr>
                <th>{{ 'statistics.my-stats.labels.performancePercentage' | transloco }}</th>
                <td
                  data-zid="my-stats-performance-percentage"
                  [ngClass]="{
                    'text-color-success': stats.performancePercentage > 0,
                    'text-color-error': stats.performancePercentage < 0,
                  }"
                >
                  {{ stats.performancePercentage | number: '1.2-2' }} %
                </td>
              </tr>
            }
          </table>
        </div>
      } @else {
        <div class="col-12 mt-4">
          <p data-zid="my-stats-no-data">
            {{ 'statistics.my-stats.no-data' | transloco }}
          </p>
        </div>
      }
    } @else {
      <div class="col-12 mt-4">
        <table class="table" aria-describedby="my-stats">
          @for (_ of [1, 2, 3, 4, 5, 6]; track $index) {
            <tr data-zid="my-stats-loading-row">
              <th><div class="loading-shimmer trade-tick"></div></th>
              <td><div class="loading-shimmer trade-tick"></div></td>
            </tr>
          }
        </table>
      </div>
    }
  </div>
</div>

<ng-template #modalContent let-modal>
  <web-design-system-modal [headline]="'statistics.my-stats.modal.headline' | transloco" (dismiss)="modal.dismiss()">
    <p>{{ 'statistics.my-stats.modal.text' | transloco }}</p>
    @if (stats?.portfolioTransferTotal !== 0) {
      <ul [innerHTML]="'statistics.my-stats.modal.itemsWithoutPortfolioTransfer' | transloco"></ul>
    }
    @if (stats?.portfolioTransferTotal === 0) {
      <ul [innerHTML]="'statistics.my-stats.modal.itemsWithPortfolioTransfer' | transloco"></ul>
    }
  </web-design-system-modal>
</ng-template>
